module.exports = __webpack_public_path__ + "images/stickers/taco-angry.0787bf33623b40f2263d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-angry.png
// module id = KATn
// module chunks = 12